export const approvalModalSelector = state => state.ui.approvalModal;
